<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <!--<a-form-item label="图表名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['chartsName']" placeholder="请输入图表名称"></a-input>
        </a-form-item>-->
        <a-form-item
          label="图表标题"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="[
              'chartsTitle',
              { rules: [{ required: true, message: '图表标题' }] }
            ]"
            placeholder="请输入图表标题"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="图表id"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['chartsId', validatorRules.chartsId]"
            placeholder="请输入图表id"
          ></a-input>
        </a-form-item>
        <!-- <a-form-item label="数据来源" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['chartsDataSource']" placeholder="请输入数据来源"></a-input>
        </a-form-item>-->
        <a-form-item
          label="数据协议url"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-decorator="['chartsProtocolUrl']"
            placeholder="请输入数据协议url"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="图表摘要"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            v-decorator="[
              'chartsDigest',
              { rules: [{ required: true, message: '图表摘要' }] }
            ]"
            rows="4"
            placeholder="请输入图表摘要"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import { validateDuplicateValue } from '@/utils/util';

export default {
  name: 'ChartsConfigModal',
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      validatorRules: {
        chartsId: {
          rules: [
            { required: true, message: '图表id' },
            {
              validator: (rule, value, callback) =>
                validateDuplicateValue(
                  'charts_config',
                  'CHARTS_ID',
                  value,
                  this.model.id,
                  callback
                )
            }
          ]
        }
      },
      url: {
        add: process.env.VUE_APP_CMS_CHARTS + '/charts/config/add',
        edit: process.env.VUE_APP_CMS_CHARTS + '/charts/config/edit'
      }
    };
  },
  created() {},
  methods: {
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'chartsName',
            'chartsId',
            'chartsTitle',
            'chartsDigest',
            'updateTime',
            'chartsDataSource',
            'chartsProtocolUrl'
          )
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          let method = '';
          if (!this.model.id) {
            httpurl += this.url.add;
            method = 'post';
          } else {
            httpurl += this.url.edit;
            method = 'post';
          }
          let formData = Object.assign(this.model, values);
          console.log('表单提交数据', formData);
          httpAction(httpurl, formData, method)
            .then(res => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'chartsName',
          'chartsId',
          'chartsTitle',
          'chartsDigest',
          'updateTime',
          'chartsDataSource',
          'chartsProtocolUrl'
        )
      );
    }
  }
};
</script>
